module.exports = __webpack_public_path__ + "static/img/popup2-swiper2.b1253ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup2-swiper2.png
// module id = kQzU
// module chunks = 0